import { useEffect } from "react";
import { useError } from "../contexts/ErrorContext.tsx";

const ErrorToast = () => {
  const { error, setError } = useError();

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [error, setError]);

  if (!error) return null;

  return (
    <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-[9999] bg-red-600 text-white px-6 py-3 rounded shadow-lg flex items-center">
      <span>{error}</span>
      <button className="ml-6 underline" onClick={() => setError(null)}>Kapat</button>
    </div>
  );
};

export default ErrorToast;